<template lang="pug">
server-data(
  search-field-name="search[name]"
  :method="getRegions"
  :start-loading-value="true"
  v-slot="{ serverData: regions, loading: isLoading, search }"
)
  ev-autocomplete(
    v-model="inputValue"
    v-bind="$attrs"
    v-on="$listeners"
    item-value="id"
    item-text="name"
    :label="label || 'Регион'"
    :items="regions"
    :loading="isLoading"
    :return-object="returnObj"
    @update:search-input="search"
  )
    template(#prepend-inner)
      slot(name="prepend-inner")

</template>

<script>
import directoryService from '@/services/API/directories';
import { PER_PAGE } from '@/constants/pagination';

export default {
  constants: {
    PER_PAGE,
  },
  props: {
    label: {
      type: [String, Boolean],
      default: '',
    },
    value: {
      type: [Number, String, Object],
      default: null,
    },
    returnObj: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputValue: {
      get() {
        return parseInt(this.value) || null;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    getRegions(additionalParams = {}) {
      const params = {
        'per-page': this.$options.constants.PER_PAGE.infinity,
        sort: 'name',
      };

      return directoryService.getRegions({ ...(additionalParams?.params || additionalParams), ...params });
    },
  },
};
</script>
